import useTiclickTableConfig from '@shared/hooks/use-ticlick-table-config';
import { Button } from '@src/design-system/button';
import AddIcon from '@shared/assets/icons/shared/add-icon';
import { TABLES_KEYS } from '@shared/constants/tables-keys';
import type { ActionItemProps } from '@src/design-system/molecules/ticlick-table/ticlick-table-table-actions';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { useHasPermission } from '@shared/hooks/use-has-permission';
import { entities } from '@shared/constants/entities';
import { hostCompaniesColumns } from '../components/table/host-companies-columns';
import RowActionsCell from '../components/table/row-actions-cell';
import { hostCompaniesApi } from '../services/host-companies-api';
import type { TPlacementHostCompany } from '@src/shared/types/placement-host-company';
import { CreateHostModal } from '../pages/create/modals/create-host-modal';
import { CustomFieldListDialogTrigger } from '@src/shared/features/custom-fields/components/custom-field-list-dialog-trigger';
import { CUSTOM_FIELD_ENTITIES } from '@src/shared/types/custom-field';

export function useHostCompaniesTable() {
  const hasPermission = useHasPermission();
  const canAddHostCompany = hasPermission(entities.placementHostCompany, 'add');

  const actionsTable: ActionItemProps<TPlacementHostCompany>[] = [
    {
      key: 'add',
      visibility: 'none-selection',
      minWidth: 77,
      render: () => (
        <Dialog>
          <DialogTrigger>
            <Button
              variant='primary'
              className='h-9 w-[77px] pr-5 text-sm font-medium rounded-xl'
            >
              <AddIcon />
              Add
            </Button>
          </DialogTrigger>
          <DialogContent
            className='max-w-[600px] rounded-2xl!'
            defaultValue={'add_hostCompany'}
          >
            <CreateHostModal isTableView />
          </DialogContent>
        </Dialog>
      ),
      isDisplay: canAddHostCompany,
    },
    {
      key: 'custom-fields',
      visibility: 'none-selection',
      minWidth: 77,
      render: () => <CustomFieldListDialogTrigger />,
    },
  ];

  const table = useTiclickTableConfig({
    options: { columns: hostCompaniesColumns },
    identifyingData: {
      tableKey: TABLES_KEYS.hostCompaniesTable,
      customFieldEntityType: CUSTOM_FIELD_ENTITIES.placementHostCompany,
    },
    fetchingData: {
      fetchFn: hostCompaniesApi.useFetch,
    },
    rowActions: [
      {
        key: 'actions',
        render: (row) => <RowActionsCell row={row} />,
        minWidth: 20,
      },
    ],
  });

  return {
    table,
    actionsTable,
  };
}
